module.exports = __webpack_public_path__ + "static/media/fun.244c4720.svg";